module.exports = __webpack_public_path__ + "static/media/wip_logo.33b620dd.png";